export default __webpack_public_path__ + "static/media/pytorch.1862724d.svg";